export default __webpack_public_path__ + "static/media/loveseat-1-seat-1-back.4aaefe7f.webp";